import {
  PaymentGatewayModelTypes,
  PaymentGatewaysTypes
} from '../../types/storesTypes';

import PaymentGateway from '../PaymentGateway';

class PaymentGateways {
  paymentServicesDetails: PaymentGatewayModelTypes[];

  constructor(paymentGateways: PaymentGatewaysTypes) {
    this.paymentServicesDetails = paymentGateways.payment_services_details.map(
      (eachPaymentGateway) => new PaymentGateway(eachPaymentGateway)
    );
  }
}

export default PaymentGateways;
